import { render, staticRenderFns } from "./StringTable.vue?vue&type=template&id=bfa151b4&scoped=true"
import script from "./StringTable.vue?vue&type=script&lang=js"
export * from "./StringTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa151b4",
  null
  
)

export default component.exports